export function formatBytes(n: number): string {
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  return (n / 1024 / 1024).toFixed(2) + ' MB';
}

export function formatDuration(sec: number | null | undefined): string {
  if (sec == null) return '—';
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}

export function fmtDuration(sec: number | null | undefined): string {
  if (sec == null) return '—';
  if (sec < 60) return sec.toFixed(0) + 's';
  if (sec < 3600) return (sec / 60).toFixed(1) + 'm';
  const h = Math.floor(sec / 3600);
  const m = Math.round((sec % 3600) / 60);
  return `${h}h ${m}m`;
}

export function distanceToKm(distance: number | null | undefined, units: string): number {
  if (distance == null) return 0;
  switch (units) {
    case 'km': return distance;
    case 'mi': return distance * 1.609344;
    case 'm':  return distance / 1000;
    default:   return distance / 1000; // default assumes meters
  }
}

export function escapeHtml(s: string): string {
  return String(s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' } as Record<string, string>
  )[c]);
}

export function shortUrl(u: string): string {
  return u.replace(/^https?:\/\//, '');
}

